var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// src/index.ts
var unset = Symbol();
function reactiveReadable(react) {
  return function(store, immutable = true) {
    const [value, set] = react.useState(unset);
    react.useEffect(
      () => store.subscribe((v) => {
        if (immutable) {
          return v;
        }
        if (Array.isArray(v)) {
          return set([...v]);
        } else if (typeof v === "object") {
          return set(__spreadValues({}, v));
        }
        return set(v);
      }),
      [store]
    );
    let valueToReturn = value;
    if (valueToReturn === unset) {
      store.subscribe((v) => {
        valueToReturn = v;
      })();
    }
    return valueToReturn;
  };
}
function reactiveWriteable(react) {
  return (store, immutable = true) => {
    const value = reactiveReadable(react)(store, immutable);
    return [value, store.set, store.update];
  };
}
function useStores(react) {
  return {
    useReadable: reactiveReadable(react),
    useWriteable: reactiveWriteable(react)
  };
}
export {
  useStores
};
